module.exports = __webpack_public_path__ + "static/img/rank_104.7c47f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_104.png
// module id = +Nkf
// module chunks = 0